import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=11744634&scoped=true"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"
import style0 from "./ProductDescription.vue?vue&type=style&index=0&id=11744634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11744634",
  null
  
)

export default component.exports